import React, { useEffect } from "react";
import {
  TouchableOpacity,
  ActivityIndicator,
  ScrollView,
  StyleSheet,
  View,
} from "react-native";
import { connect } from "react-redux";
import Text from "@components/AppText";
import Button from "@components/Button";
import { actions } from "@reducers/orderReducer";
import { actions as miscActions } from "@reducers/miscReducer";
import analytics from "@services/analytics";
import { MY_ORDERS_EVENTS } from "@constants/analyticsEventsCT";
import StarChecked from "../assets/svg/StarChecked";
import StarUnChecked from "../assets/svg/StarUnChecked";
import color from "../constants/color";
import {
  addRatingReview,
  addRatingReviewForOrder,
  getClReviewOptions,
} from "../services/api";

// Events

import t from "../constants/localization";

const PATH = "components/RatingView";

export const RatingMapping = {
  1: t(`${PATH}/1`),
  2: t(`${PATH}/2`),
  3: t(`${PATH}/3`),
  4: t(`${PATH}/4`),
  5: t(`${PATH}/5`),
};

const RatingView = (props) => {
  const { navigation } = props;
  const {
    for_order = false,
    rating_cl = 0,
    review_cl = [],
    order_id = "",
    refresh = () => {},
    delivered_at = new Date().toISOString(),
  } = props;

  const [rating, setRating] = React.useState(rating_cl);
  const [review, setReview] = React.useState(review_cl);
  const [reviewOptions, setReviewOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const fetchAllOrders = () => {
    props.getAllOrders({
      limit: 10,
      offset: 0,
      replace: true,
      isPulled: true,
    });
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await getClReviewOptions();
        if (res.status === 200) {
          setReviewOptions(res.data);
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);

  const handleRatingChange = (index) => {
    setReview([]);
    if (rating === index) {
      setRating(index - 1);
    } else {
      setRating(index);
    }
  };

  const getFormattedDate = (dateString) => {
    const date = new Date(dateString);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return `${date.getDate()} ${
      monthNames[date.getMonth()]
    } ${date.getFullYear()}`;
  };

  const handleSubmit = async () => {
    const Rating = rating;
    if (for_order) {
      analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_RATE, {
        order_id: order_id || "",
      });
      try {
        const res = await addRatingReviewForOrder({
          rating_cl: Rating,
          review_cl: review,
          order_id,
        });
        if (res.status === 200) {
          refresh();
          fetchAllOrders();
          props.refetchOrderDetails();
          navigation.goBack();
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        const res = await addRatingReview({
          rating_cl: Rating,
          review_cl: review,
        });
        if (res.status === 200) {
          refresh();
          fetchAllOrders();
          props.refetchOrderDetails();
          navigation.goBack();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: "#f7f7f7",
      }}
    >
      <ScrollView>
        <View
          style={{
            paddingHorizontal: 15,
            flex: 1,
            alignItems: "center",
          }}
        >
          <Text
            onPress={refresh}
            bold
            fontType="head3"
            style={{
              textAlign: "center",
              fontSize: 18,
              marginTop: 22,
              color: "rgba(0, 0, 0, 0.86)",
            }}
          >
            {t(`${PATH}/youCanRateUs`)}
          </Text>
          <Text
            fontType="head4"
            style={{
              textAlign: "center",
              fontSize: 18,
              color: "rgba(0, 0, 0, 0.86)",
              marginTop: 6,
            }}
          >
            {getFormattedDate(delivered_at)} {t(`${PATH}/rateDelivery`)}
          </Text>
          <View
            style={{
              width: "100%",
              marginTop: 42,
            }}
          >
            <Text
              bold
              fontType="head1"
              style={{
                textAlign: "center",
                color: "rgba(0, 0, 0, 0.86)",
                fontSize: 24,
              }}
            >
              {RatingMapping[rating]}
            </Text>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                marginTop: 15,
                marginBottom: 36,
              }}
            >
              {[1, 2, 3, 4, 5].map((x) => {
                if (x > rating) {
                  return (
                    <TouchableOpacity onPress={() => handleRatingChange(x)}>
                      <StarUnChecked />
                    </TouchableOpacity>
                  );
                }
                return (
                  <TouchableOpacity onPress={() => handleRatingChange(x)}>
                    <StarChecked />
                  </TouchableOpacity>
                );
              })}
            </View>
            <View
              style={{
                flex: 1,
                marginBottom: 20,
              }}
            >
              <Text
                bold
                fontType="head3"
                style={{
                  textAlign: "center",
                  fontSize: 18,
                  marginTop: 22,
                  color: "rgba(0, 0, 0, 0.86)",
                }}
              >
                {rating === 0
                  ? t(`${PATH}/tellUsAboutGoodOrBad`)
                  : rating > 3
                    ? t(`${PATH}/tellUsAboutGood`)
                    : t(`${PATH}/tellUsAboutBad`)}
              </Text>
              <Text
                fontType="head4"
                style={{
                  textAlign: "center",
                  fontSize: 18,
                  color: "rgba(0, 0, 0, 0.86)",
                  marginTop: 6,
                }}
              >
                {t(`${PATH}/youCanSelectOneOrMultiIssues`)}
              </Text>
            </View>

            <View>
              {loading ? (
                <ActivityIndicator color={color.primary} size="small" />
              ) : (
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {Array.isArray(reviewOptions) &&
                    reviewOptions
                      .filter((x) => x.type === RatingMapping[rating])
                      .map((item) => {
                        const isSelected = review.includes(item.id);
                        return (
                          <TouchableOpacity
                            onPress={() => {
                              if (isSelected) {
                                setReview(
                                  review.filter((id) => id !== item.id),
                                );
                              } else {
                                setReview([...review, item.id]);
                              }
                            }}
                            style={{
                              paddingVertical: 5,
                              paddingHorizontal: 10,
                              borderWidth: 1,
                              borderColor: "rgba(0, 0, 0, 0.5)",
                              borderRadius: 40,
                              margin: 5,
                              backgroundColor: isSelected
                                ? "rgba(0, 0, 0, 0.5)"
                                : "#f7f7f7",
                              // width: '30%',
                            }}
                          >
                            <Text
                              style={{
                                color: isSelected
                                  ? "#f7f7f7"
                                  : "rgba(0, 0, 0, 0.5)",
                              }}
                            >
                              {item.value}
                            </Text>
                          </TouchableOpacity>
                        );
                      })}
                </View>
              )}
            </View>
          </View>
        </View>
      </ScrollView>

      <View
        style={{
          padding: 24,
        }}
      >
        <Button
          disabled={rating < 1}
          style={{
            padding: 15,
          }}
          buttonWidth="100%"
          btnText={t(`${PATH}/submit`)}
          buttonFontType="head1"
          height={56}
          borderRadius={10}
          onPress={handleSubmit}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  dialog: {
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 5,
    elevation: 6,
    width: "85%",
  },
});

const mstp = ({ wallet, auth: { user } }) => {
  return {
    wallet,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllOrders: (payload) => dispatch(actions.getAllOrdersReq(payload)),
    refetchOrderDetails: () => dispatch(miscActions.refetchOrderDetails()),
  };
};

export default connect(mstp, mapDispatchToProps)(RatingView);
